import React from 'react'

import { Tabs, TabList, Tab, TabPanel } from 'react-tabs'

import QATaskListContainer from '../../containers/qa-tasks/qa-task-list-container'
import AreaActivityContainer from '../../containers/area-activities/area-activity-container'

export default ({
  onTabSelect,
  selectedTab,
  qaServicing,
  area
}) => (
  <Tabs onSelect={onTabSelect} selectedIndex={selectedTab}>
    <TabList>
      <Tab>Quality Checks</Tab>
      <Tab>History</Tab>
    </TabList>

    <TabPanel>
      <QATaskListContainer qaServicingId={qaServicing.id} />
    </TabPanel>

    <TabPanel>
      <AreaActivityContainer areaId={area.id} />
    </TabPanel>
  </Tabs>
)



// WEBPACK FOOTER //
// ./src/components/qa-servicings/qa-servicing-tabs.js